export const VIEW_ALL_PROJECTS_COMMAND_ID = 'view-all-projects';
export const VIEW_ALL_FILTERS_COMMAND_ID = 'view-all-filters';
export const VIEW_ALL_DASHBOARDS_COMMAND_ID = 'view-all-dashboards';
export const GO_TO_ISSUES_COMMAND_ID = 'go-to-issues';
export const GO_TO_PERSONAL_SETTINGS_COMMAND_ID = 'go-to-personal-settings';
export const VIEW_ALL_BOARDS_COMMAND_ID = 'view-all-boards';
export const GO_TO_ACCOUNT_SETTINGS_COMMAND_ID = 'go-to-account-settings';
export const VIEW_ALL_PLANS_COMMAND_ID = 'view-all-plans';
export const SITE_ADMIN_USER_MANAGEMENT = 'site-admin-user-management';
export const SITE_ADMIN_BILLING = 'site-admin-billing';

export const SHORTCUT_ICON_LABEL = 'shortcut-icon';
